export default __webpack_public_path__ + "static/media/lookbook-content-missing.33c85dd0.webm";